<template>
  <dropdown class="marketing-email-list-item-actions"
            :data-border="false"
            dataMenuWidth="115px"
            data-icon="mdi-dots-vertical"
            @hidden="hideEveryModal">

    <p v-if="!hideEdit"
       class="marketing-email-list-item-actions-item pointer"
       @click.stop="editSmsItem">
      {{$t('message.generics.message.edit')}}
    </p>

    <p v-if="!isDraft"
       class="marketing-email-list-item-actions-item pointer"
       @click="goToViewPage">
        {{$t('message.generics.message.view')}}
    </p>

    <p class="marketing-email-list-item-actions-item pointer"
       @click="showDuplicateModal">
        {{$t('message.generics.message.duplicate')}}
    </p>

    <p v-if="!hideDelete"
       class="marketing-email-list-item-actions-item pointer"
       @click.stop="showDeleteModal">
        {{$t('message.generics.message.delete')}}
    </p>

    <p v-if="isPartiallySent"
       class="marketing-email-list-item-actions-item pointer"
       @click="resend">
        Continuar envio
    </p>

    <confirmation-modal :value="showCreditDeleteModal"
                        :confirm-label="$t('message.generics.message.confirm')"
                        @confirm="deleteEmail"
                        @cancel="closeDeleteModal">
      <span slot="heading">
        {{$t('message.marketingGenerics.message.deleteMessage')}}
      </span>
      <span>
        {{$t('message.marketingGenerics.message.deleteMessageConfirmation')}}
      </span>
    </confirmation-modal>

    <marketing-create-modal-type v-model="showingDuplicateModal"
                                 :item="item"
                                 duplicate
                                 email
                                 @duplicate="duplicateEmail" />

  </dropdown>
</template>

<script>
import MarketingCreateModalType from "@components/modules/marketing/generic/create/modal/type/MarketingCreateModalType";
import ConfirmationModal from "@components/ConfirmationModal";
import Dropdown from "@components/Dropdown";
import EventBus from "@packages/event-bus";

export default {
  components: {
    Dropdown,
    ConfirmationModal,
    MarketingCreateModalType,
  },
  data() {
    return {
      showCreditDeleteModal: false,
      showingDuplicateModal: false,
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    isAutomation: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    hideEdit() {
      return (
        this.item.status === "SENT" ||
        this.item.status === "PARTIALLY_SENT_BY_CREDIT" ||
        this.item.status === "PARTIALLY_SENT_BY_SYSTEM" ||
        this.item.status === "SENDING"
      );
    },
    hideDelete() {
      return (
        this.item.status === "SENT" ||
        this.item.status === "PARTIALLY_SENT_BY_CREDIT" ||
        this.item.status === "PARTIALLY_SENT_BY_SYSTEM" ||
        this.item.status === "SENDING"
      );
    },
    isDraft() {
      return this.item.status === "DRAFT";
    },
    isPartiallySent() {
      return (this.item.status === "PARTIALLY_SENT_BY_CREDIT" || this.item.status === "PARTIALLY_SENT_BY_SYSTEM")
    }
  },
  methods: {
    hideEveryModal() {
      this.closeDeleteModal();
      this.closeDuplicateModal();
    },
    showDuplicateModal() {
      this.showingDuplicateModal = true;
    },
    closeDuplicateModal() {
      this.showingDuplicateModal = false;
    },
    showDeleteModal() {
      this.showCreditDeleteModal = true;
    },
    closeDeleteModal() {
      this.showCreditDeleteModal = false;
    },
    async deleteEmail() {
      try {
        EventBus.$emit("SHOW_SPINNER");

        await this.$api.marketing.email.message.delete({
          emailId: this.item.id,
        });

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: this.$t('message.successMessages.message.draftDeleted'),
        });

        this.closeDeleteModal();

        this.$emit("deleted");
      } catch (error) {
        //empty
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },
    goToEditPage() {
      this.$store.commit("SET_EMAIL_EDIT_ID", this.item.id);

      this.$router.push({
        path: `/marketing/email/editar/${this.item.id}/conteudo`,
      });
    },
    goToViewPage() {
      this.$router.push({
        path: `/marketing/email/editar/${this.item.id}/conteudo?viewOnly=1`,
      });
    },
    async duplicateEmail({ isAutomationFlow }) {
      await this.$api.marketing.email.message.duplicate({
        isAutomation: isAutomationFlow,
        emailId: this.item.id,
      });

      this.$emit("duplicated");
    },
    editSmsItem() {
      this.goToEditPage();
    },
    emitEdited() {
      this.$emit("edited");
    },
    async resend() {
      return new Promise(async(resolve, reject) => {
        try {
          await this.$api.marketing.email.send.resend({
            emailId: this.item.id
          })
          this.$emit("resent");
          resolve(
          EventBus.$emit("show-message", {
            type: "SUCCESS",
            message: "Envio retomado com sucesso!",
          })
          );          
        } catch (error) {
          reject(error)
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.marketing-email-list-item-actions {
  .marketing-email-list-item-actions-item {
    margin-bottom: 0px;
    font-size: 12px;
    color: #707070;
    font-weight: 600;
    margin-bottom: 5px;

    &:hover {
      transform: translateY(-1px);
    }

    &:active {
      box-shadow: none;
      transform: translateY(1px);
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
